import React, { useEffect, useRef } from 'react';

const TradingSignalBox = ({ symbol }) => {
  const containerRef = useRef(null);
  let timer = null;

  if (!symbol || typeof symbol !== 'string') return null;

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // ✅ Clean before setup
    container.innerHTML = '';

    // ✅ Delay widget injection to avoid querySelector crash
    timer = setTimeout(() => {
      if (!containerRef.current) return;

      const script = document.createElement('script');
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js';
      script.async = true;
      script.innerHTML = JSON.stringify({
        interval: '1m',
        width: '100%',
        isTransparent: false,
        height: 450,
        symbol: symbol,
        showIntervalTabs: true,
        locale: 'en',
        colorTheme: 'light',
      });

      containerRef.current.appendChild(script);
    }, 300); // 👈 Delay gives React time to mount

    return () => {
      clearTimeout(timer); // ✅ Cancel if component unmounts
      if (containerRef.current) containerRef.current.innerHTML = '';
    };
  }, [symbol]);

  return (
    <div className="bg-black rounded-lg shadow p-4 mt-6">
      <h3 className="text-md font-semibold mb-3">📊 Trading Signal for {symbol}</h3>
      <div ref={containerRef}></div>
    </div>
  );
};

export default TradingSignalBox;
